import { render, staticRenderFns } from "./TalkAreaWithCarV1.vue?vue&type=template&id=dc329abe&scoped=true&"
import script from "./TalkAreaWithCarV1.vue?vue&type=script&lang=ts&"
export * from "./TalkAreaWithCarV1.vue?vue&type=script&lang=ts&"
import style0 from "./TalkAreaWithCarV1.vue?vue&type=style&index=0&id=dc329abe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc329abe",
  null
  
)

export default component.exports